<div class="flex-row-split height100p">
    <p-panel class="flex-item-fixed width300 full-height" header="Optionen">
        <sm-form  [form]="formFilter">
        </sm-form>
        <p-button icon="fas fa-open" label="Öffnen" (onClick)="open()"></p-button>
        <p-button styleClass="mt-2" icon="fas fa-cog" label="Alle Masken als Objektdef speichern" (onClick)="saveMasksAsObjectDef()"></p-button>
    </p-panel>
    <p-tabView class="flex-item-fill height100p full-height direct-sub">
        <p-tabPanel header="Masken">
            <div class="flex-col height100p">
                <p-dropdown [styleClass]="'width300'" [options]="masksGui" [(ngModel)]="selectedMask" (onChange)="changeMask()"></p-dropdown>
                <p-tabView class="flex-item-fill height100p full-height direct-sub">
                    <p-tabPanel header="Tabellarisch">
                        <sm-table2 #wfTableComponent *ngIf="fieldsTable != null" class="height100p" [data]="fieldsTable" (onCellClicked)="editField($event)"></sm-table2>
                    </p-tabPanel>
                    <p-tabPanel header="Grafisch">
                        <app-enaio-form [fields]="selectedMaskFields"></app-enaio-form>
                    </p-tabPanel>
                </p-tabView>
            </div>
        </p-tabPanel>
        <p-tabPanel header="Variablen">
            <sm-table2 #wfTableComponent *ngIf="variablesTable != null" class="height100p" [data]="variablesTable"></sm-table2>
        </p-tabPanel>
        <p-tabPanel header="Skripte">
            <app-frontend-script-editor class="height100p" [scripts]="scripts" [toolbarTemplate]="toolbarTemplate" [showOutline]=true (onSave)="saveWorkflowScript($event)">
                <ng-template #toolbarTemplate>
                    <button pButton [disabled]="pastModels != null" icon="fas fa-open" label="Historie laden" (click)="loadHistory()"></button>
                </ng-template>                
            </app-frontend-script-editor>
        </p-tabPanel>
    </p-tabView>
</div>
